import Image from "next/image";
import { getImageMaxWidth, ImageContext } from "./imageSizing";

export function ImageRenderer(props: {
  class?: string;
  src: string;
  alt: string;
  width: number;
  height: number;
  displayMaxWidth?: number;
  type?: ImageContext;
}) {
  const maxWidth = getImageMaxWidth(
    props.width,
    props.type,
    props.type === "flashcard" ? undefined : props.displayMaxWidth
  );
  const { class: className, type, displayMaxWidth: _displayMaxWidth, ...rest } =
    props;

  return (
    <Image
      className={className}
      {...rest}
      quality={100}
      sizes={maxWidth}
      style={{
        display: "block",
        width: type === "flashcard" ? "100%" : undefined,
        maxWidth: `min(${maxWidth},100%)`,
        height: "auto",
        maxHeight: type === "flashcard" ? "250px" : "none",
        margin: type === "flashcard" || type === "notes" ? "0 auto" : "initial",
      }}
    />
  );
}
